export default __webpack_public_path__ + "static/media/training.db038f55.png";